import React from 'react'
import TextblockEditorScreen from '../textblockeditor/TextblockEditorScreen'

function Textblockeditor() {
  return (
    <React.Fragment>
      <TextblockEditorScreen />
    </React.Fragment>
  )
}

export default Textblockeditor